import { faCheck, faUndo } from "@fortawesome/pro-regular-svg-icons";
import i18n from "i18next";
import { SalesLeadActivityView } from "src/api/generated/erp/db/types/tables/salesLeadActivityView.ts";
import { SalesLeadActivitiesApi } from "src/api/generated/erp/sales/crm/salesLeadActivities/api/salesLeadActivitiesApi.ts";
import { AsyncMenuButton } from "src/components/common/contextMenu/AsyncMenuButton.tsx";
import { MenuCheckbox } from "src/components/common/contextMenu/MenuCheckbox.tsx";

interface SalesLeadActivitiesFilterMenuItemsProps {
	showOpen: boolean;
	showCompleted: boolean;
	disabled?: boolean;
	onShowOpenChange: (showOpen: boolean) => void;
	onShowCompletedChange: (showCompleted: boolean) => void;
}

interface SalesLeadActivityCompletionMenuItemsProps {
	activities: SalesLeadActivityView[];
	onCompleted: () => Promise<unknown> | void;
}

export const SalesLeadActivitiesFilterMenuItems = ({
	showOpen,
	showCompleted,
	disabled = false,
	onShowOpenChange,
	onShowCompletedChange,
}: SalesLeadActivitiesFilterMenuItemsProps) => {
	return (
		<>
			<MenuCheckbox
				label={i18n.t("show_open")}
				checked={showOpen}
				disabled={disabled}
				onChange={onShowOpenChange}
			/>
			<MenuCheckbox
				label={i18n.t("show_completed_sales_lead_activities")}
				checked={showCompleted}
				disabled={disabled}
				onChange={onShowCompletedChange}
			/>
		</>
	);
};

export const SalesLeadActivityCompletionMenuItems = ({
	activities,
	onCompleted,
}: SalesLeadActivityCompletionMenuItemsProps) => {
	const openActivityIds = activities
		.filter((activity) => activity.completedAt == null)
		.map((activity) => activity.salesLeadActivityId);
	const completedActivityIds = activities
		.filter((activity) => activity.completedAt != null)
		.map((activity) => activity.salesLeadActivityId);

	return (
		<>
			{openActivityIds.length > 0 && (
				<AsyncMenuButton
					label={i18n.t("mark_as_completed")}
					icon={faCheck}
					onClick={async () => {
						await SalesLeadActivitiesApi.markAsCompleted({
							salesLeadActivityIds: openActivityIds,
						});
						await onCompleted();
					}}
				/>
			)}
			{completedActivityIds.length > 0 && (
				<AsyncMenuButton
					label={i18n.t("revert_complete")}
					icon={faUndo}
					onClick={async () => {
						await SalesLeadActivitiesApi.reopen({
							salesLeadActivityIds: completedActivityIds,
						});
						await onCompleted();
					}}
				/>
			)}
		</>
	);
};
